var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.456V9.5625C14 10.1851 13.7777 10.7841 13.3786 11.2367C12.9795 11.6892 12.434 11.961 11.8538 11.9963L11.725 12H2.275C1.6939 12 1.13482 11.7618 0.712438 11.3342C0.290057 10.9067 0.0363991 10.3221 0.00350008 9.7005L0 9.5625V3.456L6.7564 7.248C6.83156 7.29018 6.91515 7.31222 7 7.31222C7.08485 7.31222 7.16844 7.29018 7.2436 7.248L14 3.456ZM2.275 1.77038e-08H11.725C12.2889 -7.2761e-05 12.8327 0.224247 13.251 0.62945C13.6693 1.03465 13.9322 1.59186 13.9888 2.193L7 6.1155L0.0112 2.193C0.0654664 1.61573 0.310135 1.07814 0.701225 0.676847C1.09231 0.275557 1.60418 0.0368902 2.1448 0.0037501L2.275 1.77038e-08H11.725H2.275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.6937436aee2f9893bc9960b6f1354915.svg";
export { ForwardRef as ReactComponent };